import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionLabel } from "./Reveal";

const FAQS = [
  {
    q: "Is BRICKSPACE a builder or a developer?",
    a: "No. BRICKSPACE is an independent real estate consultancy and advisory firm. We do not construct, own or sell our own projects. We advise buyers and investors on RERA-registered projects by third-party developers along the NH-24 / Delhi–Meerut Expressway corridor.",
  },
  {
    q: "Do you charge buyers for advisory?",
    a: "Our advisory, shortlisting and site visits are free for buyers. We are compensated by the developer as a registered channel partner after a transaction closes — at the same price you would pay going direct, and often lower after our negotiation.",
  },
  {
    q: "Which locations do you cover?",
    a: "We specialise in Wave City, Aditya World City and Siddharth Vihar, plus adjoining sectors on NH-24 and the Delhi–Meerut Expressway in Ghaziabad. We deliberately do not advise outside this corridor.",
  },
  {
    q: "How quickly will someone contact me?",
    a: "Within 30 minutes during business hours (9:30 AM – 8:00 PM). Enquiries after hours are called first thing the next morning, or immediately if you WhatsApp us.",
  },
  {
    q: "Can you help with home loans and registry?",
    a: "Yes. We coordinate with bank and NBFC relationship managers for pre-approval and APF-listed projects, and we accompany you through agreement and registry formalities.",
  },
  {
    q: "Do you handle resale and rental too?",
    a: "Yes — resale inventory and rental advisory within the same corridor, including yield expectations sector by sector.",
  },
];

export const FaqSection = () => (
  <section id="faq" data-testid="faq-section" className="bg-white py-20 lg:py-28">
    <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-5 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-4">
        <Reveal>
          <SectionLabel index="05">FAQ</SectionLabel>
          <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl">
            Questions buyers actually ask us
          </h2>
          <p className="mt-4 text-base text-body">
            Still unsure about something? Call us — we answer the awkward ones too.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.08}>
          <Accordion type="single" collapsible className="w-full space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="card-soft border border-line px-5"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-base font-bold text-ink hover:text-brand hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-body">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
